import React from 'react';
import './Legend.css';


const getColorForType = (type) => {
    switch (type) {
      case 53:
        return "#339FFF";
      case "Bac Jaune":
        return "#ffff00";
      case 55:
        return "#ffff00";
      case 15:
        return "#22834b";
      case 11:
        return "#4f4f4f";
      case 3:
        return "#8b4513";
      case 32:
        return "#8ab13d";
      case 52:
        return "#adc9c5";
      case 54:
        return "#d873ed";
      case 58:
        return "#0000DD";
      case 73:
        return "#800000";
      default:
        return "#3E3EE3";
    }
  };

const Legend = ({ collectionTypes }) => {
  const legendItems = [
    { color: '#3E3EE3', label: 'Déchets ménagers' },
    { color: '#339FFF', label: 'Emballages et papiers' },
    { color: '#ffff00', label: 'Collecte sélective' },
    { color: '#22834b', label: 'Déchets verts' },
    { color: '#4f4f4f', label: 'Verre' },
    { color: '#8b4513', label: 'Encombrants' },
    { color: '#8ab13d', label: 'Ordures ménagères' },
    { color: '#adc9c5', label: 'Tri sélectif' },
    { color: '#d873ed', label: 'Déchets spéciaux' },
    { color: '#0000DD', label: 'Déchets industriels' },
    { color: '#800000', label: 'Déchets dangereux' },
  ];

  // Filtrer les éléments de légende en fonction des types de collecte récupérés


  return (
    <div className="legend-container">
        {collectionTypes.map((type) => (
            <div key={type.type} className="legend-item">
                <div className="legend-inner">
                    <div
                        className="legend-color"
                        style={{ backgroundColor: getColorForType(type.type) }}
                    ></div>
                    <span className="legend-label">{type.type1}</span>
                </div>
            </div>
        ))}
    </div>
);
};

export default Legend;
